/**
 * Get Current User (Application)
 *
 * Imperative API for fetching the current user.
 * Used by auth initialization and other cross-module callers.
 * Presentation layer should use useCurrentUser() for React components.
 */

import { userRepository } from '../infrastructure/repositories';

import type { UserResponse } from '../domain/types';

/**
 * Fetches the current authenticated user from the API.
 */
export async function getCurrentUser(): Promise<UserResponse> {
  return userRepository.getCurrentUser();
}
